import { createResolverRegistry } from '../resolvers/resolverRegistry';
import { toLoading } from '../resolvers/resolverState';
import { createEntityStateEmitter } from './entityStateEmitter';
import { createEntityLifecycleManager } from '../lifecycleManager/entityLifecycleManager';
import { maybeCreateDevtools } from '../devtools/maybeCreateDevtools';
export const createController = ({
  httpClient
}) => {
  const stateEmitters = createEntityStateEmitter();
  const resolverRegistry = createResolverRegistry({
    httpClient
  });
  const lifecycleManager = createEntityLifecycleManager({
    onStateChange: stateEmitters.emit,
    onInvalidate: (entity, instanceKey) => {
      if (resolverRegistry.isAttached({
        instanceKey,
        entity
      })) {
        resolverRegistry.refresh({
          instanceKey,
          entity
        });
      } else {
        // No resolver attached, manually mark this entity as stale for next attachment
        lifecycleManager.markStale(entity, instanceKey);
      }
    }
  });
  void maybeCreateDevtools();
  return {
    invalidate: ({
      entity,
      params,
      instanceKey = entity.identifyInstance(params)
    }) => lifecycleManager.invalidate(entity, instanceKey),
    getState: ({
      entity,
      params,
      instanceKey = entity.identifyInstance(params)
    }) => lifecycleManager.getState(entity, instanceKey),
    watch: ({
      entity,
      params,
      instanceKey = entity.identifyInstance(params)
    }, callback) => {
      // Attach if first subscriber
      if (stateEmitters.count(entity, instanceKey) === 0) {
        const emptyInitial = toLoading()();
        const getState = () => lifecycleManager.getState(entity, instanceKey);
        resolverRegistry.attach({
          entity,
          instanceKey,
          params,
          getState: () => getState() || emptyInitial,
          onResolverUpdate: resolverState => lifecycleManager.handleStateChange(entity, instanceKey, resolverState)
        });
        const state = getState();
        if (!state || state.stale || state.loading) {
          resolverRegistry.refresh({
            instanceKey,
            entity
          });
        }
      }
      const unsubscribe = stateEmitters.subscribe(entity, instanceKey, callback);
      return () => {
        // Detach if last subscriber
        if (unsubscribe() === 0) {
          resolverRegistry.detach({
            instanceKey,
            entity
          });
          // TODO: Queue for cache GC
        }
      };
    }
  };
};